import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import swiper from 'swiper';

if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });


/* slide
----------------------- */
var mySwiper = new Swiper ('.home-slide', {
	loop: true,
	speed:500,
	autoplay:3000,
	effect:"slide",
	spaceBetween:48,
	nextButton: '.swiper-button-next',
	prevButton: '.swiper-button-prev',
	slidesPerView: 'auto',
	centeredSlides: true,
	breakpoints: {
		768:{
			spaceBetween:0,
		}
	}
});

/* gnav
----------------------- */
$(".menu-trigger").on("click",function(){
	$(this).toggleClass("active");
	$(".gnav").toggleClass("active");
});


let w = $(window);
let scrl = 0;
w.on("load scroll",function(){
	scrl = w.scrollTop();
	let slideH = $(".home-slide").height();
	// console.log(scrl);

	if(scrl < slideH ){
		$("body.home .header").addClass("onslide");
		$("body.home .menu-trigger").addClass("onslide");
	}else{
		$("body.home .header").removeClass("onslide");
		$("body.home .menu-trigger").removeClass("onslide");
	}

	if(scrl > 300 ){
		$(".header").addClass("scrolled");
	}else{
		$(".header").removeClass("scrolled");
	}

	//背景画像のパス取得
	// let bgImgPath = $(".mainimg").css("backgroundImage");
	// bgImgPath = bgImgPath.replace( /(url\(|\)|")/g, '' );
	// console.log(bgImgPath);

	//背景画像のサイズ取得
	// var img = new Image();
	// img.src = bgImgPath;
	// var height = img.height; // 高さ
	// console.log(height);


	// var yPos =  $(".mainimg").css("backgroundPositionY");

	// var yPos =  height * 0.5 - (scrl/8);
	// var yPos =  height * 0.5 ;
	// var yPos =  50 - (scrl/8);
	// console.log(yPos);
	// var resultPosition = '50%' + yPos +'%';
	// $(".mainimg").css("backgroundPosition",resultPosition);

	//mainig
	if(!$("body").hasClass("home")){
		$(".mainimg").css("bottom",-(scrl/3)+"px");
	}
});


// WEBPACK FOOTER //
// ./dev/js/scripts/main.js